var render = function (_h,_vm) {var _c=_vm._c;return _c('button',{staticClass:"obj-button obj-button--secondary flt-container-opener",attrs:{"type":"button","data-load":"elements/filter/container-opener"}},[_vm._v(" "+_vm._s(_vm.props.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }